import request, { METHODS } from '@/api'
import UrlConfig from '@/api/UrlConfigs'

// 接听状态
export function getCallState() {
  return request(`/clue-web/enums/com.shj.saas.clue.enums.CallState`, {
    method: METHODS.GET,
  })
}

// 呼叫类型
export function getCallType() {
  return request(`/clue-web/enums/com.shj.saas.clue.enums.CallType`, {
    method: METHODS.GET,
  })
}

// 派单坐席(云客服列表)
export function getQueryCallUser() {
  return request(`${UrlConfig.Clue.QueryCallUser}1/9999`, {
    method: METHODS.POST,
    data: {},
  })
}

//  通话记录 - 列表
export function getAudioRecordList(current, pageSize, params = {}) {
  return request(UrlConfig.PlusCrmWeb.GetAudioRecordPage, {
    method: METHODS.POST,
    data: params,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

//  通话记录 - 导出
export function exportAudioRecord(params = {}) {
  return request(UrlConfig.PlusCrmWeb.ExportAudioRecord, {
    method: METHODS.POST,
    data: params,
  })
}

// 通话记录 - 评定
export function audioRecordConformity(params = {}) {
  return request(UrlConfig.PlusCrmWeb.AudioRecordConformity, {
    method: METHODS.POST,
    data: params,
    raw: true,
  })
}

//  呼叫管理
export function getCallPage(current, pageSize, params = {}) {
  return request(UrlConfig.PlusCrmWeb.GetCallPage, {
    method: METHODS.POST,
    data: params,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

export function callBatchReceive(data = {}) {
  return request(UrlConfig.PlusCrmWeb.CallBatchReceive, {
    method: METHODS.POST,
    data,
  })
}
export function addClue(data = {}) {
  return request(UrlConfig.PlusClueWeb.AddClue, {
    method: METHODS.POST,
    data,
  })
}

export function getClueDetail(clueId) {
  return request(UrlConfig.PlusCrmWeb.GetClueDetail + clueId, {
    method: METHODS.GET,
  })
}

export function cluePending(data = {}) {
  return request(UrlConfig.PlusCrmWeb.CluePending, {
    method: METHODS.POST,
    data,
  })
}

export function callValid(data = {}) {
  return request(UrlConfig.PlusCrmWeb.CallValid, {
    method: METHODS.POST,
    data,
  })
}

export function callCenterInvValid(data = {}) {
    return request(UrlConfig.PlusCrmWeb.CallInvValid, {
        method: METHODS.POST,
        data
    })
}

export function callInvValid(data = {}) {
  return request(UrlConfig.PlusCrmWeb.startClueInvaildProcess.replace('{clueId}', data.clueId), {
    method: METHODS.POST,
    data,
  })
}

export function submitLost(data: any = {}) {
  return request(UrlConfig.PlusCrmWeb.startClueLostProcess.replace('{trackPlanId}', data.trackPlanId), {
    method: METHODS.POST,
    data,
  })
}

export function clueAppointment(data = {}) {
  return request(UrlConfig.PlusCrmWeb.ClueAppointment, {
    method: METHODS.POST,
    data,
  })
}

export function clueConfirmToShop(data = {}) {
  return request(UrlConfig.PlusCrmWeb.ClueConfirmToShop, {
    method: METHODS.POST,
    data,
  })
}

export function queryClueDispatchFlag(clueId) {
  return request(UrlConfig.PlusCrmWeb.QueryClueDispatchFlag + clueId, {
    method: METHODS.POST,
  })
}
export function getTrackDetailByClueId(clueId) {
    return request(UrlConfig.PlusCrmWeb.GetTrackDetailByClueId + clueId, {
        method: METHODS.POST,
    })
}
export function getBizTypes() {
    return request(UrlConfig.PlusCrmWeb.GetBizTypes, {
        method: METHODS.GET,
    }).then(res => {
      const keys = Object.keys(res || {})
      return keys?.map(key => ({key, description: res[key]}))
    })
}
// 无效列表
export function salesReceive(clueId) {
    return request(UrlConfig.PlusCrmWeb.SalesReceive + clueId, {
        method: METHODS.POST,
    })
}
export function salesSeaDispatch(data) {
    return request(UrlConfig.PlusCrmWeb.SalesSeaDispatch, {
      method: METHODS.POST,
      data,
    })
}
export function salesSeaBatchDispatch(data) {
    return request(UrlConfig.PlusCrmWeb.SalesSeaBatchDispatch, {
      method: METHODS.POST,
      data,
    })
}
export function salesBatchReceive(data) {
    return request(UrlConfig.PlusCrmWeb.SalesBatchReceive, {
      method: METHODS.POST,
      data,
    })
}
export function queryClueEmployeeForReassign(data = {}, params = {pageId:1, pageSize: 10}) {
  return request(UrlConfig.PlusCrmWeb.QueryClueEmployeeForReassign, {
    method: METHODS.POST,
    data,
    params,
  })
}

export function callDispatchSales(data = {}) {
  return request(UrlConfig.PlusCrmWeb.CallDispatchSales, {
    method: METHODS.POST,
    data,
  })
}

export function callAppointDispatch(data = {}) {
  return request(UrlConfig.PlusCrmWeb.CallAppointDispatch, {
    method: METHODS.POST,
    data,
  })
}

export function clueFollowLogList(data = {}) {
  return request(UrlConfig.PlusCrmWeb.ClueFollowLogList, {
    method: METHODS.POST,
    data,
  })
}

export function clueFollowLogAdd(data = {}) {
  return request(UrlConfig.PlusCrmWeb.ClueFollowLogAdd, {
    method: METHODS.POST,
    data,
  })
}
export function assignEmployee(data = {}) {
  return request(UrlConfig.PlusCrmWeb.AssignEmployee, {
    method: METHODS.POST,
    data,
  })
}

// 改派
export function queryEmployeePage(options = { params: { pageId: 1, pageSize: 9999 }, data: {} }) {
  return request(UrlConfig.PlusCrmWeb.QueryEmployeePage, {
    method: METHODS.POST,
    ...options,
  })
}
export function queryAnchor(companyId, type) {
  return request(UrlConfig.PlusCrmWeb.QueryAnchor + `${companyId}/${type}`, {
    method: METHODS.GET,
  })
}

export function clueBizConver(data = {}) {
  return request(UrlConfig.PlusCrmWeb.ClueBizConver, {
    method: METHODS.POST,
    data,
  })
}

export function viewPhoneByClueId(clueId) {
  return request(UrlConfig.PlusCrmWeb.ViewPhoneByClueId + clueId, {
    method: METHODS.GET,
  })
}
// 查看电话号码-资源key
export function viewPhoneBySource(clueId, key) {
  return request(UrlConfig.PlusCrmWeb.ViewPhoneBySource + clueId + '/' + key, {
    method: METHODS.GET,
  })
}
// 新增云客服邀约
export function appointmentForCall(data = {}) {
  return request(UrlConfig.PlusCrmWeb.AppointmentForCall, {
    method: METHODS.POST,
    data,
  })
}
